<template>
    <div class="newkf">
        <div class="newkf-header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/admin/logManagement' }"
                    >日志管理</el-breadcrumb-item
                >
                <el-breadcrumb-item>登录日志</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="search_con">
                <div class="search_box">
                    <span class="label">登录名：</span>
                    <el-input v-model="params.username" placeholder="请输入登录名字查询"></el-input>
                </div>
                <div class="search_box">
                    <span class="label">用户名：</span>
                    <el-input v-model="params.nickname" placeholder="请输入用户名查询"></el-input>
                </div>
                <div class="search_box">
                    <span class="label">角色分类：</span>
                    <el-select v-model="params.role_id" placeholder="请选择">
                        <el-option
                            v-for="item in roleOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="search_box">
                    <span class="label">日期：</span>
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <el-button
                    style="color: #fff; background: #1122d8; border: none"
                    type="primary"
                    icon="el-icon-search"
                    @click="getLogData"
                    >搜索</el-button
                >
                <el-button style="color: #1122d8; margin-left: 0" type="text" @click="clearSearch"
                    >清除条件</el-button
                >
            </div>
        </div>
        <el-table
            ref="multipleTable"
            selection
            :data="logList"
            border
            style="width: 100%; margin-top: 20px; flex: 1"
            height="1%"
            size="medium"
            :header-cell-style="{
                fontWeight: 'normal',
                height: '60px',
                color: '#13131B',
                background: '#F2F3FA',
            }"
            :cell-style="{ fontSize: '14px', color: '#343441' }"
        >
            <el-table-column prop="nickname" label="用户名"></el-table-column>
            <el-table-column prop="username" label="登录名"></el-table-column>
            <el-table-column prop="role" label="角色"></el-table-column>
            <el-table-column prop="content" label="操作内容"></el-table-column>
            <el-table-column prop="time" label="操作时间"></el-table-column>
        </el-table>
        <el-pagination
            class="pager-center"
            style="margin-top: 10px"
            :current-page="params.page"
            :page-size="params.pageSize"
            :total="total"
            layout="prev, pager, next, jumper"
            @current-change="currentChange"
        >
        </el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            params: {
                paging: 1,
                page: 1,
                pageSize: 10,
                username: '',
                nickname: '',
                role_id: -1,
                time: null,
            },
            total: 0,
            time: [],
            logList: [],
            roleOption: [
                {
                    label: '全部',
                    value: -1,
                },
                {
                    label: '总管理员',
                    value: 0,
                },
                {
                    label: '学校管理员',
                    value: 1,
                },
                {
                    label: '训练管理员',
                    value: 2,
                },
                {
                    label: '评委',
                    value: 3,
                },
                {
                    label: '学生',
                    value: 4,
                },
            ],
        };
    },
    components: {},
    methods: {
        getLogData() {
            this.params.time = this.time.join(',');
            this.$http.axiosGetBy(
                this.$api.logloginNotice,
                this.params,
                res => {
                    if (res.code === 200) {
                        this.logList = res.data.list;
                        this.total = res.data.total;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.msg,
                            duration: 1000,
                        });
                    }
                },
                err => {
                    this.$common.axiosErrorMsg(err);
                }
            );
        },
        clearSearch() {
            this.params.username = '';
            this.params.nickname = '';
            this.params.role_id = -1;
            this.params.time = '';
            this.time = [];
            this.getLogData();
        },
        currentChange(val) {
            this.params.page = val;
            this.getLogData();
        },
    },
    mounted() {
        this.getLogData();
    },
};
</script>

<style scoped lang="scss">
.newkf {
    padding: 30px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .search_con {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        margin-top: 20px;
        gap: 20px;
        .search_box {
            display: flex;
            align-items: center;

            .label {
                display: inline-block;
                flex-shrink: 0;
            }
        }
    }
}
::v-deep .el-table--border th.el-table__cell.gutter:last-of-type {
    background: #f2f3fa !important;
}
</style>
